export function Dialog({ open, onClose, title, children, size = 'md', contentClassName = '' }) {
  if (!open) return null;

  const sizeToMax = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl'
  };
  const maxW = sizeToMax[size] || sizeToMax.md;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-25" 
          onClick={onClose}
        />

        {/* Dialog */}
        <div className={`relative bg-white rounded-lg shadow-xl ${maxW} w-full p-6 ${contentClassName}`}>
          <h2 className="text-xl font-semibold mb-4">{title}</h2>
          {children}
        </div>
      </div>
    </div>
  );
} 